var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BaseLayersTreeItem, { attrs: { item: _vm.item } }, [
    _c("div", { staticClass: "layer-row pl-2" }, [
      _c("div", { staticClass: "grow-1 d-flex items-center pr-1" }, [
        _c(
          "div",
          {
            staticClass: "action cursor-pointer no-drag",
            on: {
              "!click": function ($event) {
                $event.preventDefault()
                return _setup.onCollapseClick()
              },
            },
          },
          [
            _vm.collapsed
              ? _c("font-awesome-icon", {
                  staticClass: "mr-1 action-icon",
                  attrs: { icon: ["fas", "chevron-right"] },
                })
              : _c("font-awesome-icon", {
                  staticClass: "mr-1 action-icon",
                  attrs: { icon: ["fas", "chevron-down"] },
                }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icon mr-2" },
          [
            _setup.isSpotifyPlayer
              ? [
                  _c(
                    _setup.CLazy,
                    { staticClass: "d-flex items-center element-icon" },
                    [
                      _c(_setup.SvgIcon, {
                        attrs: { src: require(`../../../assets/spotify.svg`) },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _setup.isLayout
              ? [
                  _c(
                    "div",
                    { staticClass: "d-flex items-center element-icon" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1 status-icon",
                        attrs: { icon: ["fak", "branch"] },
                      }),
                    ],
                    1
                  ),
                ]
              : _setup.hasAnyLayout
              ? [
                  _c(
                    "div",
                    { staticClass: "d-flex items-center element-icon" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1 status-icon",
                        attrs: { icon: ["fak", "layouts-group"] },
                      }),
                    ],
                    1
                  ),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "d-flex items-center element-icon" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mr-1 status-icon",
                        attrs: { icon: ["fas", "layer-group"] },
                      }),
                    ],
                    1
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "layers-element-title grow-1" },
          [
            _c(_setup.EditableText, {
              attrs: {
                value: _vm.item.element.name,
                "default-text": _vm.item.element.name,
                "allow-editing": !_setup.flags?.readonly,
                tooltip: "Edit",
              },
              on: { input: _setup.onElementTitleChange },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _setup.flags?.allowViewPositionGroup && _vm.item.element.position != 0
        ? _c(
            "div",
            { staticClass: "layers-element-title shrink cursor-pointer" },
            [
              _c(_setup.EditableText, {
                attrs: {
                  value: _vm.item.element.position || "",
                  label: "ID",
                  type: "number",
                  "allow-editing": _setup.flags?.allowPositionGroupEdit,
                },
                on: { input: _setup.onElementPositionChange },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }